import { urlPlaceholders } from 'constants/urlPlaceholders';

const buildResourceUrl = (url, userId, hash, video) =>
  url
    .replace(urlPlaceholders.userId, userId)
    .replace(urlPlaceholders.video, video)
    .replace(urlPlaceholders.hash, hash);

export default buildResourceUrl;
